// extracted by mini-css-extract-plugin
module.exports = {"selectTag":"FilterBar_selectTag__2KVv6"};